import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1170px;
  margin: ${Spacing.S16} auto ${Spacing.S32};
  padding: 0 ${Spacing.S24};
`
